import React from "react";
import PropTypes from "prop-types";

/**
 * 재사용 가능한 문서 요약 카드
 * - title: 카드 상단 제목
 * - sections: [{ label, value }] 형태로 좌우 2컬럼 그리드 표현
 * - blocks: [{ label, content }] 형태로 긴 텍스트/단락
 * - list: [{ label, items: [string] }] 형태로 요약 리스트
 * - footerNote: 하단 작은 통계/요약 문구
 */
export default function DocSummaryCard({
  title = "요약",
  sections = [],
  blocks = [],
  list = [],
  footerNote = "",
  className = "",
}) {
  return (
    <div className={`border rounded-xl p-4 shadow-sm ${className}`}>
      <h3 className="font-semibold mb-2">{title}</h3>

      {/* Key-Value 섹션 (2열) */}
      {sections.length > 0 && (
        <div className="grid grid-cols-2 gap-3 text-sm">
          {sections.map((s, i) => (
            <div key={i}>
              <div className="text-gray-500">{s.label}</div>
              <div className="font-medium break-words">{s.value ?? "-"}</div>
            </div>
          ))}
        </div>
      )}

      {/* 텍스트 블록 */}
      {blocks.length > 0 && (
        <div className="mt-3 text-sm space-y-2">
          {blocks.map((b, i) => (
            <div key={i}>
              {b.label && <div className="text-gray-500">{b.label}</div>}
              <div className="font-medium whitespace-pre-wrap">
                {b.content ?? "-"}
              </div>
            </div>
          ))}
        </div>
      )}

      {/* 리스트 */}
      {list.length > 0 && (
        <div className="mt-3 text-sm space-y-3">
          {list.map((g, gi) => (
            <div key={gi}>
              {g.label && <div className="text-gray-500 mb-1">{g.label}</div>}
              <ul className="list-disc list-inside space-y-1">
                {(g.items || []).map((it, ii) => (
                  <li key={ii} className="break-words">
                    {it}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}

      {footerNote && (
        <div className="mt-2 text-xs text-gray-500">{footerNote}</div>
      )}
    </div>
  );
}

DocSummaryCard.propTypes = {
  title: PropTypes.string,
  sections: PropTypes.arrayOf(
    PropTypes.shape({ label: PropTypes.string, value: PropTypes.node })
  ),
  blocks: PropTypes.arrayOf(
    PropTypes.shape({ label: PropTypes.string, content: PropTypes.node })
  ),
  list: PropTypes.arrayOf(
    PropTypes.shape({ label: PropTypes.string, items: PropTypes.array })
  ),
  footerNote: PropTypes.string,
  className: PropTypes.string,
};
